<template>
  <div>
    <!-- 面包屑导航 -->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>钱包管理</el-breadcrumb-item>
    </el-breadcrumb> -->
    <!-- 搜索筛选 -->

    <el-card class="box-card" v-loading="loadings">
      <h3>
         <span>统计搜索 ( 生成时间：{{ new Date(sumData.generateAt*1000).toLocaleString() }} )</span>
        <p>系统赢{{ sumData.sysWin }}</p>
      </h3>
      <p v-if="sumData.userName">用户名 ： {{ sumData.userName }}</p>
      <div>
        <p v-if="sumData.start">开始时间 ：{{ sumData.start }}</p>
        <p v-if="sumData.end">结束时间 ：{{ sumData.end }}</p>
      </div>
      <p>下L总 ：{{ sumData.lSettles }}</p>
      <p>下M总 ：{{ sumData.mSettles }}</p>
      <div class="box-card-div">
        
        <p>总赢 ：{{ sumData.win }}</p>
        <p>赢的局数 ：{{ sumData.winCount }}</p>
        <p>下总 ：{{ sumData.settles }}</p>
        <p>总局数 ：{{ sumData.count }}</p>
        <p>赢的金额比例 ：{{ (sumData.winRate *100).toFixed(2) }}%</p>
        <p>赢的局数比例 ：{{ (sumData.winCountRate *100).toFixed(2) }}%</p>
        
      </div>
      
      
    </el-card>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="用户名">
        <el-input size="small" v-model="formInline.userName" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="币种">
        <el-select size="small" v-model="formInline.tokenName" placeholder="请选择">
          <el-option v-for="item in typeToken" :label="item.key" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
        size="small"
        v-model="timeVal"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      </el-form-item>
      
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" icon="el-icon-search" @click="getDepositSum">统计搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center"  prop="orderId" label="订单Id" min-width="100">
      </el-table-column>
      <el-table-column align="center"  prop="userName" label="用户名" min-width="200">
      </el-table-column>
      <el-table-column align="center"  prop="address" label="接收地址" min-width="200">
      </el-table-column>
      <el-table-column align="center" prop="tokenName" label="币种" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="amount" label="下数量" min-width="100">
      </el-table-column>
      <el-table-column align="center"  prop="win" label="赢" min-width="100">
      </el-table-column>
      <el-table-column align="center" label="结果" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.result == 1">大</div>
            <div v-if="scope.row.result == 2">小</div>
          </template>
        </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 'finish'">完成</div>
            <div v-if="scope.row.status == 'waiting'">等待</div>
          </template>
        </el-table-column>
      <el-table-column align="center" label="txId" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.txId != ''"><el-link icon="el-icon-link" type="primary" :underline="false" :title="scope.row.txId" :href="scope.row.url" target="_blank">{{ scope.row.txId.slice(0,6)+'……'+scope.row.txId.substr(scope.row.txId.length-6,6) }}</el-link></div>
          <div v-else>无</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="setupTime" label="创建时间" min-width="200">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import { XySum , XyList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      loadings: false, //是显示加载
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        from: 1,
        limit: 10,
        startTime: "",
        endTime: "",
        tokenName: "",
        userName: ""
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      typeToken: [
        { key: '请选择', value: '' },
        { key: 'Lucky', value: 'Lucky' },
        { key: 'MCoin', value: 'MCoin' },
      ],
      timeVal:"",
      sumData:{
        // 用户名 
        userName : null,
        // 开始时间 
        start: null,
        // 结束时间 
        end: null,
        // 下总  
        settles: null,
        // 下M总 
        mSettles: null,
        // 下L总 
        lSettles: null,
        // 总赢 
        win: null,
        // 总局数  
        count: null,
        // 生成时间 
        generateAt: null,
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getDepositSum()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      XyList(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.from
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },

    getDepositSum() {
      if(this.timeVal instanceof Array){
        this.formInline.startTime = this.timeVal[0]+' 00:00:00'
        this.formInline.endTime = this.timeVal[1]+' 23:59:59'
      }else{
        this.formInline.startTime = ''
        this.formInline.endTime = ''
      }
      let obj = {
        "startTime": this.formInline.startTime,
        "endTime": this.formInline.endTime,
        "tokenName": this.formInline.tokenName,
        "userName":this.formInline.userName,
        "orderId": "",
        "hash": "",
      }
      console.log(this.formInline)
      this.loadings = true
        XySum(obj).then(res => {
          this.loadings = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.sumData = res.data
          }
        })
        .catch(err => {
          this.loadings = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },

    // 搜索事件
    search() {
      this.pageparm.currentPage = 1
      this.formInline.from = 1
      console.log(this.timeVal)
      if(this.timeVal instanceof Array){
        this.formInline.startTime = this.timeVal[0]+' 00:00:00'
        this.formInline.endTime = this.timeVal[1]+' 23:59:59'
      }else{
        this.formInline.startTime = ''
        this.formInline.endTime = ''
      }
      this.getdata(this.formInline)
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.box-card{
  width: 600px;
  margin-top: 20px;
  font-size: 14px;
}
.box-card div{
  display: flex;
}
.box-card div p{margin-right: 10px;}
.box-card p{margin: 0;margin-bottom: 10px;}
.box-card h3{margin: 0;margin-bottom: 15px;display: flex;justify-content: space-between;}
.box-card h3 p{text-align: right;}
.box-card-div{
  display: flex;
  flex-wrap: wrap;
}
.box-card-div p{width: 260px;}
</style>

 
 


// WEBPACK FOOTER //
// src/views/wallet/Lucky.vue